import React from "react";
import * as Tools from "../../../../helpers/Tools";
import SummaryItemGroup from "./SummaryItemGroup";

const MammographyYes = ({ inputData }) => {

    const details = [
        {
            title: "Date of Mammogram",
            info: `${inputData?.pMonth ? Tools.getFullMonthName(inputData?.pMonth) : ""} ${inputData?.pYear ? inputData?.pYear : ""}`
        },
        {
            title: "Facility",
            info: <>
                {inputData?.name && <div>{inputData?.name}</div>}
                {inputData?.pNumber && <div>P: {inputData?.pNumber}</div>}
                {inputData?.faxNumber && <div>F: {inputData?.faxNumber}</div>}
                {(inputData?.city || inputData?.state) && 
                    <div>
                        {inputData?.city && <span>{inputData?.city}</span>}
                        {inputData?.state && <span>{inputData?.city ? ", " : ""}{inputData?.state}</span>}
                    </div>
                }
            </>
        }];

    const attachments = inputData?.attachments?.map((file) => ({
        fileName: file.FileName,
        fileSize: file.FileSize,
        variant: "file"
    }));

    const summaryItems = attachments && attachments.length > 0 ? details.concat(attachments) : details;

    return (
        <SummaryItemGroup
            summaryItems={summaryItems}
        />
    );
};

export default MammographyYes;